import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICameraChangeInfo } from 'app/models/activity-log.model';

@Pipe({
  name: 'formatCameraDetails',
  standalone: true,
  pure: true
})
export class FormatCameraDetailsPipe implements PipeTransform {
  constructor(private translate: TranslateService) {
    const translations = this.translate.instant(["ENABLED", "DISABLED", "MOTION_DETECTION", "ANONYMIZED_VISIT", "VIEW_CLEAR_IMAGE", "VISIT_WITH_ALERT", "SNAPSHOT_WITH_ALERT", "VIDEOCLIP_WITH_ALERT"]);

    this.ENABLED = translations.ENABLED.toLowerCase();
    this.DISABLED = translations.DISABLED.toLowerCase();
    this.MOTION_DETECTION = translations.MOTION_DETECTION;
    this.ANONYMIZED_VISIT = translations.ANONYMIZED_VISIT;
    this.VIEW_CLEAR_IMAGE = translations.VIEW_CLEAR_IMAGE;
    this.VISIT_WITH_ALERT = translations.VISIT_WITH_ALERT;
    this.SNAPSHOT_WITH_ALERT = translations.SNAPSHOT_WITH_ALERT;
    this.VIDEOCLIP_WITH_ALERT = translations.VIDEOCLIP_WITH_ALERT;
  }

  readonly ENABLED: string;
  readonly DISABLED: string;
  readonly MOTION_DETECTION: string;
  readonly ANONYMIZED_VISIT: string;
  readonly VIEW_CLEAR_IMAGE: string;
  readonly VISIT_WITH_ALERT: string;
  readonly SNAPSHOT_WITH_ALERT: string;
  readonly VIDEOCLIP_WITH_ALERT: string;

  transform(camera: ICameraChangeInfo): string {
    let string = ""

    if (camera.motionDetection != null) {
    string += `${this.MOTION_DETECTION} ${camera.motionDetection ? this.ENABLED : this.DISABLED}; `
    }
    if (camera.anonymizedVisit != null) {
    string += `${this.ANONYMIZED_VISIT} ${camera.anonymizedVisit ? this.ENABLED : this.DISABLED}; `
    }
    if (camera.clearImage != null) {
      string += `${this.VIEW_CLEAR_IMAGE} ${camera.clearImage ? this.ENABLED : this.DISABLED}; `
    }
    if (camera.visitWithAlert != null) {
      string += `${this.VISIT_WITH_ALERT} ${camera.visitWithAlert ? this.ENABLED : this.DISABLED}; `
    }
    if (camera.snapshotWithAlert != null) {
      string += `${this.SNAPSHOT_WITH_ALERT} ${camera.snapshotWithAlert ? this.ENABLED : this.DISABLED}; `
    }
    if (camera.videoclipWithAlert != null) {
      string += `${this.VIDEOCLIP_WITH_ALERT} ${camera.videoclipWithAlert ? this.ENABLED : this.DISABLED}; `
    }

    return string;
  }
}
